/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TypeEnum = 0 | 1 | 2 | 3;

export const TypeEnum = {
    News: 0 as TypeEnum,
    CaseStudy: 1 as TypeEnum,
    Media: 2 as TypeEnum,
    Webinar: 3 as TypeEnum
};

